import React from "react";
import { Link } from "react-router-dom";
import { T } from "./I18n";

type User = {
  id?: string;
  userName: string;
  type?: 'USER' | 'SERVICE_ACCOUNT';
};

type UserLinkProps = {
  user: User;
};

export function UserLink({user}: UserLinkProps) {
  if (!user.id || !user.type || user.type !== 'USER') {
    return <T variable="username">{user.userName}</T>;
  }

  return <Link to={`/users/${user.id}`}><T variable="username">{user.userName}</T></Link>;
}
